<script setup lang="ts">
/**
 * PWA Update Prompt — gutted.
 *
 * The previous implementation registered `/app/sw.js`, which doesn't exist
 * (the SW build was removed but this registration was left behind, throwing
 * a 404 on every page load and noisy console errors).
 *
 * This stub:
 *   1. Renders nothing (the install / update UI was tied to the SW which
 *      was tied to the missing sw.js — none of it worked).
 *   2. Unregisters any leftover service workers so users who registered a
 *      previous version don't keep getting a dead controller serving stale
 *      cache. Defensive — we can delete this file once we're confident no
 *      user has an old SW installed.
 *
 * If/when PWA features are wanted again, build a real SW via vite-plugin-pwa
 * and replace this with the proper Workbox-backed update flow.
 */
import { onMounted } from 'vue';

onMounted(async () => {
  if (!('serviceWorker' in navigator)) return;
  try {
    const regs = await navigator.serviceWorker.getRegistrations();
    for (const reg of regs) {
      await reg.unregister();
    }
  } catch {
    // best-effort cleanup; never throw to the host page
  }
});
</script>

<template>
  <!-- intentionally renders nothing -->
</template>
